




































import {
    defineComponent,
    inject,
    computed,
    ref,
    onMounted,
} from '@vue/composition-api'

// Store
import { StoreKey as FormStoreKey } from '@/store/Form'
import { StoreKey as InputStoreKey } from '@/store/Input'
import { StoreKey as ErrorStoreKey } from '@/store/Error'
import { StoreKey as ValidatedStoreKey } from '@/store/Validated'

// Util
import { useValidate } from '@/ts/util/validate'

export default defineComponent({
    setup(_, { root }) {
        const formStore = inject(FormStoreKey)
        if (!formStore) {
            throw new Error(`${FormStoreKey} is not provided`)
        }
        const inputStore = inject(InputStoreKey)
        if (!inputStore) {
            throw new Error(`${InputStoreKey} is not provided`)
        }
        const errorStore = inject(ErrorStoreKey)
        if (!errorStore) {
            throw new Error(`${ErrorStoreKey} is not provided`)
        }
        const validatedStore = inject(ValidatedStoreKey)
        if (!validatedStore) {
            throw new Error(`${ValidatedStoreKey} is not provided`)
        }

        const validateHandler = useValidate(
            {
                required: ref(true),
            },
            (result, flag) => {
                validatedStore.tel = flag

                const messages: string[] = []
                if (result.required === false) {
                    messages.push(formStore.error_message.error_tel || '')
                }

                if (messages.length) {
                    errorStore.tel.value = [...messages]
                } else {
                    errorStore.tel.value = null
                }
            }
        )

        const inputFieldClass = computed(() => {
            return {
                'm-invalid':
                    errorStore.tel.value !== null || validatedStore.tel === -1,
                'm-verify': validatedStore.tel === 1,
            }
        })

        onMounted(() => {
            if (inputStore.tel) {
                validateHandler(inputStore.tel)
            }
        })

        return {
            tel_field_placeholder: computed(() => {
                return root.$data.tel_field_placeholder ?? '例）0120541008'
            }),
            tel_field_help: computed(() => {
                return (
                    root.$data.tel_field_help ??
                    '※「-（ハイフン）」のご入力は必要ありません。'
                )
            }),
            inputStore,
            errorStore,
            validatedStore,
            inputFieldClass,
            validateHandler,
        }
    },
})
